(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["blksh-v2-home"] && !Shopify.designMode) return;
  try {
    
function initBLKSHHero(){
  document.querySelectorAll('[data-hero-video]').forEach(video=>{
    if(video.dataset.initialized)return;
    video.dataset.initialized='true';
    const motion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const sources=[...video.querySelectorAll('source[data-src]')];
    const sync=()=>{
      if(motion.matches){
        video.pause();video.hidden=true;
        sources.forEach(source=>source.removeAttribute('src'));
        video.load();
      }else{
        video.muted=true;
        sources.forEach(source=>source.src=source.dataset.src);
        video.hidden=false;video.load();
        video.play().catch(()=>{});
      }
    };
    video.addEventListener('error',()=>{video.hidden=true;});
    motion.addEventListener('change',sync);
    sync();
  });
}
initBLKSHHero();
document.addEventListener('shopify:section:load',initBLKSHHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
